import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ClickableTextPanel } from "@/Common/Components/ClickableText/ClickableTextPanel";
import { SimpleTextareaResizable } from "@/Common/Components/Inputs/SimpleTextareaResizable";
import { Popup } from "@/Common/Components/Modals/Popup";
import { Guid } from "@/Common/Models/Guid";
import { InboundFaxNotes } from "@/Documents/Models/InboundFax/InboundFaxNotes";
import { InboundFaxNoteList } from "./InboundFaxNoteList";

import "./InboundFaxNotesPopup.css";

interface InboundFaxNotesPopupProps {
    faxId: Guid,
    existingFaxNotes: InboundFaxNotes[];
    onAccept: (faxId: Guid, note: string) => void;
    onCancel: () => void;
}

class InboundFaxNotesPopupState {
    public faxId: Guid;
    public note: string;
    public existingFaxNotes: InboundFaxNotes[];
    public isNoteClickableTextShown: boolean;
}

class InboundFaxNotesPopup extends BaseReactComponent<InboundFaxNotesPopupProps, InboundFaxNotesPopupState> {
    private inboundFaxNotesField: string = "inboundFaxNotesPopup_NotesField";

    public constructor(props: InboundFaxNotesPopupProps) {
        super(props);
        this.state = { existingFaxNotes: this.props.existingFaxNotes, faxId: this.props.faxId, note: "", isNoteClickableTextShown: false };
    }

    public render(): JSX.Element {
        return (
            <div onClick={() => this.containerClick()} className="inbound-fax-notes-popup-overlay">
                <Popup
                    cssClass="inbound-fax-notes-popup"
                    draggable
                    manageOverlay
                    onCloseDelegate={() => this.props.onCancel()}
                    disableAutoStyling={false}
                    isOverflowVisible={true}
                    standardFooterProps={{
                        cancelButton: {
                            label: cacheStore.GetString("CancelLabel"),
                            onClick: () => { this.props.onCancel(); },
                            className: "btn btn-default push-right-5"
                        },
                        okButton: {
                            label: cacheStore.GetString("SubmitLabel"),
                            onClick: () => {
                                this.props.onAccept(this.state.faxId, this.state.note);
                            },
                            disabled: IsNullOrWhiteSpace(this.state.note),
                            className: "btn btn-primary inbound-fax-notes-right"
                        }
                    }}
                >
                    <div role="form">
                        <InboundFaxNoteList faxNotes={this.props.existingFaxNotes} />
                        <SimpleTextareaResizable
                            id={this.inboundFaxNotesField}
                            className="form-control textarea-resize-vertical"
                            rows={4}
                            value={this.state.note}
                            onChange={e => this.editNotes(e)}
                            maxLength={1000}
                            autoFocus
                        />
                        {this.state.isNoteClickableTextShown && (
                            <div className="clickable-text-container" style={{ width: "500px" }}>
                                <ClickableTextPanel
                                    cssClass="text-helper-container"
                                    context="InboundFaxNotes"
                                    inputElementId={this.inboundFaxNotesField}
                                    onCloseEvent={() => this.toggleClickableNotesVisibility()}
                                />
                            </div>
                        )}
                        <a
                            className="clickable-text-link"
                            onClick={() => this.toggleClickableNotesVisibility()}
                        >
                            {cacheStore.GetString("SelectFromListLabel")}
                        </a>
                    </div>

                </Popup>
            </div>
        );
    }

    public containerClick(): void {
        this.state.isNoteClickableTextShown && this.toggleClickableNotesVisibility();
    }

    private editNotes(e: React.ChangeEvent<HTMLTextAreaElement>): void {
        const val = e.target.value;
        this.mutateState(s => s.note = val);
    }

    private toggleClickableNotesVisibility(): void {
        this.mutateState(s => s.isNoteClickableTextShown = !s.isNoteClickableTextShown);
    }
}

export { InboundFaxNotesPopup };
